import { LOGISTA_KEY, LOGISTA_VAL } from '../../../../constants/default-settings';

export const Utils = {
  isLogista: (obj: { [LOGISTA_KEY]: string } | null) => (obj ? obj[LOGISTA_KEY] === LOGISTA_VAL : false),
};
